import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";export const styles = (theme: Theme) => {
	return ({
		root: {
			backgroundColor: theme.palette.secondary.main,
		},
		title: {
			color: theme.palette.secondary.contrastText,
			fontSize: theme.typography.h4.fontSize,
		},
	} satisfies Record<string, CSSObject>)
}